export default {
    documents: [],
    document: {
        attachments: [],
        comments: [],
        status: {}
    },
    productionDepartments: [],
    types: [],
    statuses: [],
    productionDepartmentsLoading: false,
    typesLoading: false,
    statusesLoading: false,
    documentsLoading: false,
    uploadCancelTokens: [],
    attachments: []
}
